(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["face-capture"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const roots = document.querySelectorAll('.quiz-face-capture');
    roots.forEach(sectionRoot => {
      if (sectionRoot.dataset.qfcInit === '1') return;
      sectionRoot.dataset.qfcInit = '1';

      const steps = sectionRoot.querySelectorAll('.quiz-face-capture__step');
      const nameInput = sectionRoot.querySelector('input[name="name"]');
      const emailInput = sectionRoot.querySelector('input[name="email"]');
      const phoneInput = sectionRoot.querySelector('input[name="phone"]');
      let submitted = false;
      const sheetURL = 'https://script.google.com/macros/s/AKfycbzRqzieFFKSLaVjBG5qLdSx2Yw_QdN-j1f4o3RjWP9BB6KZGGgm7BlELEJs86LojibodA/exec';

      function validateName() {
        const name = (nameInput.value || '').trim();
        if (!name) {
          alert('Please enter your name.');
          nameInput.focus();
          return false;
        }
        return true;
      }

      function showStep(stepNumber) {
        steps.forEach(step => {
          step.classList.toggle('is-active', Number(step.dataset.step) === stepNumber);
        });
      }

      function triggerKwikpassPopup() {
        const accountSelectors = ['#kp-login-button-header-logo'];
        const triggerUserClick = element => {
          ['pointerdown', 'mousedown', 'mouseup', 'click'].forEach(type => {
            element.dispatchEvent(new MouseEvent(type, { bubbles: true, cancelable: true, view: window }));
          });
        };

        for (let i = 0; i < accountSelectors.length; i += 1) {
          const accountNode = document.querySelector(accountSelectors[i]);
          if (accountNode) {
            triggerUserClick(accountNode);
            return true;
          }
        }

        if (window.KwikPass && typeof window.KwikPass.open === 'function') return window.KwikPass.open(), true;
        if (window.KwikPass && typeof window.KwikPass.openModal === 'function') return window.KwikPass.openModal(), true;
        if (window.kwikpass && typeof window.kwikpass.open === 'function') return window.kwikpass.open(), true;
        if (window.SimplifyMyLogin && typeof window.SimplifyMyLogin.open === 'function') return window.SimplifyMyLogin.open(), true;

        const triggerSelectors = [
          '[data-kwikpass-login]',
          '[data-kp-login]',
          '.kwikpass-login',
          '.kp-login',
          '[href*="kwikpass"]',
          '[class*="kwikpass"]'
        ];
        for (let i = 0; i < triggerSelectors.length; i += 1) {
          const node = document.querySelector(triggerSelectors[i]);
          if (node) {
            node.click();
            return true;
          }
        }
        return false;
      }

      function validateContact() {
        const email = (emailInput.value || '').trim();
        const phone = (phoneInput.value || '').trim();
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const phonePattern = /^[0-9]{7,15}$/;
        if (!emailPattern.test(email)) {
          alert('Please enter a valid email.');
          emailInput.focus();
          return false;
        }
        if (!phonePattern.test(phone)) {
          alert('Please enter a valid mobile number.');
          phoneInput.focus();
          return false;
        }
        return true;
      }

      sectionRoot.addEventListener('click', event => {
        const trigger = event.target.closest('[data-action]');
        if (!trigger) return;
        const action = trigger.dataset.action;

        if (action === 'start') {
          if (!validateName()) return;
          triggerKwikpassPopup();
          showStep(2);
        }

        if (action === 'back') {
          showStep(1);
        }

        if (action === 'submit') {
          if (!validateContact() || submitted) return;
          submitted = true;
          const data = {
            name: (nameInput.value || '').trim(),
            email: (emailInput.value || '').trim(),
            phone: (phoneInput.value || '').trim()
          };

          fetch(sheetURL, {
            method: 'POST',
            mode: 'no-cors',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
          })
            .then(() => {
              showStep(3);
            })
            .catch(() => {
              submitted = false;
              alert('Unable to submit data right now. Please try again.');
            });
        }

      });

      showStep(1);
    });
  }());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();

      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);

      if (this.classList.contains('on-header')) {
        document.body.classList.remove('localization--open');
      }
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      // this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      // this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());

      if (this.classList.contains('on-header')) {
        document.body.classList.toggle('localization--open');
      }
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }
  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["h_bundle"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root = document.querySelector('[data-helium-section="h_bundle"]');
  if(!root) return;
  var money = function(n){ return '₹' + Math.round(n).toLocaleString('en-IN'); };
  var SAVE_RATE = 0.15;
  var inputs = Array.prototype.slice.call(root.querySelectorAll('.bundle-check-input'));
  var countEl = root.querySelector('[data-bundle-count]');
  var subEl = root.querySelector('[data-bundle-subtotal]');
  var saveEl = root.querySelector('[data-bundle-save]');
  var payEl = root.querySelector('[data-bundle-pay]');
  var cta = root.querySelector('[data-bundle-cta]');
  var errEl = root.querySelector('[data-bundle-error]');

  function priceOf(input){
    var card = input.closest('.bundle-card');
    var el = card && card.querySelector('.bundle-card-price');
    var v = parseFloat(el && el.getAttribute('data-price'));
    return isNaN(v) ? 0 : v;
  }

  function render(){
    var count = 0, sub = 0;
    inputs.forEach(function(i){ if(i.checked){ count++; sub += priceOf(i); } });
    var save = count > 1 ? Math.round(sub * SAVE_RATE) : 0;
    if(countEl) countEl.textContent = count + (count === 1 ? ' product selected' : ' products selected');
    if(subEl) subEl.textContent = money(sub);
    if(saveEl) saveEl.textContent = save > 0 ? '− ' + money(save) : money(0);
    if(payEl) payEl.textContent = money(sub - save);
  }

  inputs.forEach(function(i){ i.addEventListener('change', render, { passive: true }); });
  render();

  document.addEventListener('helium:variant-change', function(ev){
    if(!ev.detail || !ev.detail.variant) return;
    var heroInput = root.querySelector('.bundle-card--hero .bundle-check-input');
    var heroPrice = root.querySelector('.bundle-card--hero .bundle-card-price');
    if(ev.detail.variant.id != null && heroInput) heroInput.setAttribute('data-variant-id', ev.detail.variant.id);
    if(heroPrice && ev.detail.variant.price != null){
      heroPrice.setAttribute('data-price', (ev.detail.variant.price/100).toFixed(2));
      if(ev.detail.priceFormatted) heroPrice.textContent = ev.detail.priceFormatted;
    }
    render();
  });

  function notifyAndOpenDrawer(cart){
    try {
      if(typeof window.publish === 'function' && window.PUB_SUB_EVENTS){
        window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'helium-bundle', cartData: cart });
      }
    } catch(e){}
    ['cart:refresh','cart:updated','cart:build','cart-drawer:open','ajaxProduct:added'].forEach(function(name){
      document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: { cart: cart } }));
    });
    var drawer = document.querySelector('cart-drawer, #CartDrawer, .cart-drawer, .drawer--cart, #cart-drawer, .js-drawer--cart');
    if(drawer){
      if(typeof drawer.open === 'function'){ try { drawer.open(); } catch(e){} }
      drawer.classList.add('active','is-open','open','drawer--is-open');
      drawer.setAttribute('open','');
      document.body.classList.add('cart-drawer-open','js-drawer-open');
    }
  }

  if(cta){
    cta.addEventListener('click', function(e){
      e.preventDefault();
      e.stopPropagation();
      var items = inputs
        .filter(function(b){ return b.checked; })
        .map(function(b){ return { id: parseInt(b.getAttribute('data-variant-id'), 10), quantity: 1 }; })
        .filter(function(it){ return it.id && !isNaN(it.id); });
      if(!items.length) return;
      if(errEl){ errEl.hidden = true; errEl.textContent = ''; }
      cta.classList.add('is-loading');
      cta.disabled = true;
      var labelEl = cta.querySelector('.bundle-cta-label');
      var labelText = labelEl ? labelEl.textContent : '';
      var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
      fetch(base + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function(r){
          if(!r.ok) return r.json().then(function(j){ throw new Error(j.description || 'Could not add to cart'); });
          return r.json();
        })
        .then(function(){
          return fetch(base + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function(r){ return r.json(); });
        })
        .then(function(cart){
          cta.classList.remove('is-loading');
          cta.classList.add('is-done');
          cta.disabled = false;
          if(labelEl) labelEl.textContent = 'Added ✓';
          setTimeout(function(){ cta.classList.remove('is-done'); if(labelEl) labelEl.textContent = labelText; }, 1800);
          notifyAndOpenDrawer(cart);
        })
        .catch(function(err){
          cta.classList.remove('is-loading');
          cta.disabled = false;
          if(errEl){ errEl.textContent = err.message || 'Something went wrong.'; errEl.hidden = false; }
        });
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["h_bundle_sec_vitamin_c_and_ferulic_acid_serum"] && !Shopify.designMode) return;
  try {
    
(function () {
  var SEL = '[data-helium-section="h_bundle_sec_vitamin_c_and_ferulic_acid_serum"]';
  var root = document.querySelector(SEL);
  if (!root) return;
  var fmt = function (n) { return '\u20B9' + Math.round(n).toLocaleString('en-IN'); };
  var boxes = Array.prototype.slice.call(root.querySelectorAll('.bundle-cb'));
  var countEl = root.querySelector('[data-count]');
  var strikeEl = root.querySelector('[data-strike]');
  var saveEl = root.querySelector('[data-save]');
  var totalEl = root.querySelector('[data-total]');
  var addBtn = root.querySelector('[data-bundle-add]');
  var errEl = root.querySelector('[data-bundle-error]');

  function recalc() {
    var subtotal = 0, count = 0;
    boxes.forEach(function (b) {
      var item = b.closest('.bundle-item');
      if (b.checked) {
        subtotal += parseFloat(b.getAttribute('data-price')) || 0;
        count++;
        if (item && !item.classList.contains('is-locked')) item.classList.add('is-on');
      } else if (item) {
        item.classList.remove('is-on');
      }
    });
    var save = count > 1 ? Math.round(subtotal * 0.1) : 0;
    if (countEl) countEl.textContent = count;
    if (strikeEl) strikeEl.textContent = fmt(subtotal);
    if (saveEl) saveEl.textContent = save > 0 ? '-' + fmt(save) : fmt(0);
    if (totalEl) totalEl.textContent = fmt(subtotal - save);
  }

  boxes.forEach(function (b) {
    var item = b.closest('.bundle-item');
    if (item && b.checked) item.classList.add('is-on');
    b.addEventListener('change', recalc, { passive: true });
  });

  document.addEventListener('helium:variant-change', function (ev) {
    var anchor = boxes[0];
    if (anchor && ev.detail && ev.detail.variant && ev.detail.variant.id != null) {
      anchor.setAttribute('data-variant-id', ev.detail.variant.id);
      if (ev.detail.variant.price != null) {
        anchor.setAttribute('data-price', (ev.detail.variant.price / 100).toString());
      }
      recalc();
    }
  });

  // Refresh cart UI + open the drawer, across common theme conventions. No navigation.
  function notifyAndOpenDrawer(cart) {
    // 1) Update any cart-count bubbles so the header reflects the new count immediately.
    if (cart && typeof cart.item_count === 'number') {
      document.querySelectorAll(
        '.cart-count, .cart-count-bubble, [data-cart-count], #CartCount, .site-header__cart-count, .cart-link__bubble'
      ).forEach(function (el) {
        var numTarget = el.querySelector('span') || el;
        numTarget.textContent = cart.item_count;
        el.classList.remove('hidden', 'is-empty');
      });
    }

    // 2) Dawn / Horizon pub-sub
    try {
      if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
        window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'helium-bundle', cartData: cart });
      }
    } catch (e) {}

    // 3) Common custom events various themes listen for
    ['cart:refresh', 'cart:updated', 'cart:build', 'cart:change', 'ajaxProduct:added'].forEach(function (name) {
      document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: { cart: cart } }));
    });

    // 4) Open the drawer element directly (Dawn = <cart-drawer>; others use these)
    var drawer = document.querySelector('cart-drawer, #CartDrawer, .cart-drawer, .drawer--cart, #cart-drawer, .js-drawer--cart, #cart-notification, cart-notification');
    if (drawer) {
      if (typeof drawer.open === 'function') { try { drawer.open(); } catch (e) {} }
      drawer.classList.add('active', 'is-open', 'open', 'drawer--is-open', 'animate');
      drawer.setAttribute('open', '');
      document.body.classList.add('cart-drawer-open', 'js-drawer-open');
    }
  }

  if (addBtn) {
    addBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var items = boxes
        .filter(function (b) { return b.checked; })
        .map(function (b) { return { id: parseInt(b.getAttribute('data-variant-id'), 10), quantity: 1 }; })
        .filter(function (it) { return it.id && !isNaN(it.id); });
      if (!items.length) return;
      if (errEl) { errEl.hidden = true; errEl.textContent = ''; }
      addBtn.disabled = true;
      var label = addBtn.textContent;
      addBtn.textContent = 'Adding...';
      var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';

      fetch(base + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || 'Could not add to cart'); });
          return r.json();
        })
        .then(function () {
          return fetch(base + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          addBtn.disabled = false;              // <-- the fix: re-enable
          addBtn.textContent = 'Added';
          setTimeout(function () { addBtn.textContent = label; }, 1800);
          notifyAndOpenDrawer(cart);            // stay on page, refresh + open drawer
        })
        .catch(function (err) {
          addBtn.disabled = false;
          addBtn.textContent = label;
          if (errEl) { errEl.textContent = err.message || 'Something went wrong.'; errEl.hidden = false; }
        });
    });
  }

  recalc();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["h_cross_sell_vitamin_c_and_ferulic_acid_serum"] && !Shopify.designMode) return;
  try {
    
(function(){
  var section = document.querySelector('[data-helium-section="h_cross_sell_vitamin_c_and_ferulic_acid_serum"]');
  if(!section) return;
  var root = section.querySelector('.embla');
  if(!root || !window.EmblaCarousel) return;
  var embla = window.EmblaCarousel(root, { loop: true, align: 'start', dragFree: true, containScroll: 'trimSnaps' });
  var prev = section.querySelector('.cs-prev');
  var next = section.querySelector('.cs-next');
  if(prev) prev.addEventListener('click', function(){ embla.scrollPrev(); }, { passive: true });
  if(next) next.addEventListener('click', function(){ embla.scrollNext(); }, { passive: true });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["h_cross_sell_vitamin_c_and_ferulic_acid_serum_2"] && !Shopify.designMode) return;
  try {
    
(function(){
  var section = document.querySelector('[data-helium-section="h_cross_sell_vitamin_c_and_ferulic_acid_serum_2"]');
  if(!section) return;
  var root = section.querySelector('.embla');
  if(!root || !window.EmblaCarousel) return;
  var embla = window.EmblaCarousel(root, { loop: true, align: 'start', dragFree: true, containScroll: 'trimSnaps' });
  var prev = section.querySelector('.cs-prev');
  var next = section.querySelector('.cs-next');
  if(prev) prev.addEventListener('click', function(){ embla.scrollPrev(); }, { passive: true });
  if(next) next.addEventListener('click', function(){ embla.scrollNext(); }, { passive: true });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["h_details"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root = document.querySelector('[data-helium-section="h_details"]');
  if(!root) return;
  var tabs = Array.prototype.slice.call(root.querySelectorAll('.dc-tab'));
  var panels = Array.prototype.slice.call(root.querySelectorAll('.dc-panel'));
  function select(tab){
    tabs.forEach(function(t){
      var on = t === tab;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
    });
    panels.forEach(function(p){
      p.hidden = p.getAttribute('aria-labelledby') !== tab.id;
    });
  }
  tabs.forEach(function(tab, i){
    tab.addEventListener('click', function(){ select(tab); }, { passive: true });
    tab.addEventListener('keydown', function(e){
      var idx = i;
      if(e.key === 'ArrowRight'){ idx = (i+1)%tabs.length; }
      else if(e.key === 'ArrowLeft'){ idx = (i-1+tabs.length)%tabs.length; }
      else return;
      e.preventDefault();
      tabs[idx].focus();
      select(tabs[idx]);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["h_edd"] && !Shopify.designMode) return;
  try {
    
(function(){
  var scope = document.querySelector('[data-helium-section="h_edd"]');
  if(!scope) return;
  var tabs = Array.prototype.slice.call(scope.querySelectorAll('.edd-tab'));
  var panels = Array.prototype.slice.call(scope.querySelectorAll('.edd-panel'));
  function select(tab){
    tabs.forEach(function(t){
      var on = t === tab;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
    });
    panels.forEach(function(p){
      p.hidden = p.getAttribute('aria-labelledby') !== tab.id;
    });
  }
  tabs.forEach(function(tab, i){
    tab.addEventListener('click', function(){ select(tab); }, { passive: true });
    tab.addEventListener('keydown', function(e){
      var idx = i;
      if(e.key === 'ArrowRight'){ idx = (i + 1) % tabs.length; }
      else if(e.key === 'ArrowLeft'){ idx = (i - 1 + tabs.length) % tabs.length; }
      else return;
      e.preventDefault();
      tabs[idx].focus();
      select(tabs[idx]);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["h_hero"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.querySelector('[data-helium-section="h_hero"]');
  if(!root)return;
  var main=root.querySelector('#hero-main-img');
  var thumbs=root.querySelectorAll('.thumb');
  thumbs.forEach(function(t){
    t.addEventListener('click',function(){
      thumbs.forEach(function(x){x.classList.remove('is-active');x.setAttribute('aria-selected','false');});
      t.classList.add('is-active');t.setAttribute('aria-selected','true');
      var src=t.getAttribute('data-src');
      if(src&&main)main.src=src;
    },{passive:true});
  });
  var qtyInput=root.querySelector('.qty-input');
  root.querySelectorAll('.qty-btn').forEach(function(b){
    b.addEventListener('click',function(){
      if(!qtyInput)return;
      var step=parseInt(b.getAttribute('data-step'),10)||1;
      var v=parseInt(qtyInput.value,10)||1;
      v=Math.max(1,Math.min(10,v+step));
      qtyInput.value=v;
    },{passive:true});
  });
  // sync price label on variant change (cross-section bus)
  document.addEventListener('helium:variant-change',function(ev){
    if(!ev.detail||!ev.detail.priceFormatted)return;
    var p=root.querySelector('[data-pdp-price]');
    var ps=root.querySelector('[data-pdp-price-sticky]');
    if(p)p.textContent=ev.detail.priceFormatted;
    if(ps)ps.textContent=ev.detail.priceFormatted;
  });
  // sticky CTA reveal via IntersectionObserver on hero ATC
  var heroAtc=root.querySelector('#hero-atc');
  var sticky=root.querySelector('#sticky-cta');
  if(heroAtc&&sticky&&'IntersectionObserver' in window){
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if(en.isIntersecting){sticky.classList.remove('is-visible');sticky.setAttribute('aria-hidden','true');}
        else{sticky.classList.add('is-visible');sticky.setAttribute('aria-hidden','false');}
      });
    },{threshold:0});
    io.observe(heroAtc);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["h_hero_vitamin_c_and_ferulic_acid_serum"] && !Shopify.designMode) return;
  try {
    
(function(){
  function bootHeroVcSerum() {
  var root = document.querySelector('[data-helium-section="h_hero_vitamin_c_and_ferulic_acid_serum"]');
  if (!root) return false;

  // Gallery sliding is handled by the inline slider script.
  if (root.getAttribute('data-helium-hero-bound') === '1') return true;
  root.setAttribute('data-helium-hero-bound', '1');

  var qtyInput = root.querySelector('.qty-input');
  root.querySelectorAll('.qty-btn').forEach(function(b){
    b.addEventListener('click', function(){
      if (!qtyInput) return;
      var step = parseInt(b.getAttribute('data-step'), 10) || 1;
      var value = parseInt(qtyInput.value, 10) || 1;
      qtyInput.value = Math.max(1, Math.min(10, value + step));
    });
  });

  var variantsNode = root.querySelector('[data-product-variants-json]');
  var variants = [];
  try {
    variants = variantsNode ? JSON.parse(variantsNode.textContent) : [];
  } catch (error) {
    console.error('Unable to parse product variants', error);
  }

  var productForm = root.querySelector('form[id^="hero-vc-product-form-"]');
  var variantIdInput = productForm && productForm.querySelector('[data-selected-variant-id]');
  var heroAtc = root.querySelector('#hero-atc');
  var stickyAtc = root.querySelector('.sticky-atc');
  var ctaLabel = root.getAttribute('data-atc-label') || 'Add to cart';

  function normalizedPrices(variant) {
    var sale = Number(variant.upgrade_sale_price) || 0;
    var original = Number(variant.upgrade_original_price) || 0;
    var discounted = original > sale;

    return {
      sale: sale,
      original: original,
      saleFormatted: variant.upgrade_sale_price_formatted,
      originalFormatted: variant.upgrade_original_price_formatted,
      discounted: discounted,
      percent: Number(variant.upgrade_discount_pct) || 0
    };
  }

  function setText(selector, value) {
    var el = root.querySelector(selector);
    if (el) el.textContent = value;
  }

  function setOptional(selector, visible, value) {
    var el = root.querySelector(selector);
    if (!el) return;
    el.hidden = !visible;
    el.textContent = visible ? value : '';
  }

  function updateButton(button, available) {
    if (!button) return;
    button.disabled = !available;
    button.setAttribute('aria-disabled', available ? 'false' : 'true');
    var label = button.querySelector('.atc-label');
    if (label) label.textContent = available ? ctaLabel : 'Sold out';
  }

  function updateVariant(variant) {
    if (!variant) return;

    if (variantIdInput) variantIdInput.value = variant.id;

    var prices = normalizedPrices(variant);
    setText('[data-pdp-price]', prices.saleFormatted);
    setText('[data-pdp-price-sticky]', prices.saleFormatted);
    setOptional('[data-pdp-compare-price]', prices.discounted, prices.originalFormatted);
    setOptional('[data-pdp-compare-price-sticky]', prices.discounted, prices.originalFormatted);
    setOptional('[data-pdp-discount]', prices.discounted, '-' + prices.percent + '% Off');
    setOptional('[data-pdp-discount-sticky]', prices.discounted, '-' + prices.percent + '% Off');

    updateButton(heroAtc, Boolean(variant.available));
    updateButton(stickyAtc, Boolean(variant.available));
  }

  function findVariantById(id) {
    return variants.find(function(variant){ return String(variant.id) === String(id); });
  }

  function findVariantFromSelectedOptions() {
    var picker = root.querySelector('variant-selects, variant-radios, [data-variant-picker], .product-variant-picker') || root;
    var selected = [];

    picker.querySelectorAll('select[name^="options"], input[type="radio"][name^="options"]:checked').forEach(function(input){
      selected.push(input.value);
    });

    if (!selected.length) return null;

    return variants.find(function(variant){
      return selected.every(function(value, index){
        return String(variant.options[index]) === String(value);
      });
    }) || null;
  }

  function syncFromPicker(event) {
    var detail = event && event.detail ? event.detail : {};
    var variant = detail.variant || detail.selectedVariant || null;
    var id = detail.variantId || detail.id || (variant && variant.id);

    if (!variant && id) variant = findVariantById(id);

    if (!variant && event && event.target) {
      var targetId = event.target.value;
      if (event.target.name === 'id' || event.target.matches('[data-variant-id]')) {
        variant = findVariantById(targetId);
      }
    }

    if (!variant) variant = findVariantFromSelectedOptions();
    if (variant) updateVariant(variant);
  }

  ['helium:variant-change', 'variant:change', 'product:variant-change'].forEach(function(eventName){
    document.addEventListener(eventName, syncFromPicker);
  });

  root.addEventListener('change', function(event){
    if (event.target.matches('select, input[type="radio"], input[name="id"], [data-variant-id]')) {
      window.requestAnimationFrame(function(){ syncFromPicker(event); });
    }
  });

  // ATC click handling lives in the inline section script (Hyperspeed-safe)

  // Offer code copy (Available Offers in buy box)
  root.addEventListener('click', function(event){
    var btn = event.target.closest('[data-offer-copy]');
    if (!btn || !root.contains(btn)) return;
    var code = btn.getAttribute('data-code') || '';
    if (!code) return;
    var done = function(){
      var prev = btn.textContent;
      btn.textContent = 'Copied!';
      btn.classList.add('is-copied');
      clearTimeout(btn._offerTimer);
      btn._offerTimer = setTimeout(function(){
        btn.textContent = prev || 'Copy';
        btn.classList.remove('is-copied');
      }, 1600);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done).catch(done);
    } else {
      done();
    }
  });

  var sticky = root.querySelector('#sticky-cta');
  if (heroAtc && sticky && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        var visible = !entry.isIntersecting;
        sticky.classList.toggle('is-visible', visible);
        sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
      });
    }, { threshold: 0 });
    io.observe(heroAtc);
  }

  return true;
  }

  // Hyperspeed may run compiled section JS before the section HTML exists
  if (!bootHeroVcSerum()) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function(){ bootHeroVcSerum(); });
    }
    var bootTries = 0;
    var bootTimer = setInterval(function(){
      if (bootHeroVcSerum() || ++bootTries > 50) clearInterval(bootTimer);
    }, 100);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.connectedCallback();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 100);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
